import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'


const TaskFilterContext = createContext();

const toFilterRequest = (filtersList) => {
    return (filtersList || [])
        .map((filter) => ({
            Field: filter.selectedFilterKey && typeof filter.selectedFilterKey === 'object' ? filter.selectedFilterKey?.id : '',
            Operator: filter.selectedFilterCompareKey && typeof filter.selectedFilterCompareKey === 'object' ? filter.selectedFilterCompareKey?.label : '',
            Value: filter.selectedFilterType && typeof filter.selectedFilterType === "object"
                ? filter.selectedFilterType?.value && typeof filter.selectedFilterType.value === 'number'
                    ? filter.selectedFilterType.value.toString()
                    : filter.selectedFilterType?.value
                : '',
        }))
        .filter((item) =>
            item.Field?.trim() !== "" &&
            item.Operator?.trim() !== "" &&
            item.Value !== undefined &&
            item.Value !== null &&
            item.Value !== ""
        );
};

export const TaskFilterProvider = ({ children }) => {

    const initialFilter = useCallback(() => ({
        id: Date.now(),
        selectedFilterKey: null,
        selectedFilterCompareKey: null,
        selectedFilterType: null,
        selectedFilterTypeOptions: [],
    }), []);

    const [filters, setFilters] = useState([initialFilter()]);
    const [filterRequest, setFilterRequest] = useState([]);

    const applyFilter = useCallback(() => {
        setFilterRequest(toFilterRequest(filters));
    }, [filters]);

    const addFilter = useCallback(() => {
        setFilters((prevFilters) => [...prevFilters, initialFilter()]);
    }, [initialFilter]);

    const updateFilter = useCallback((id, updates) => {
        setFilters((prevFilters) =>
            prevFilters.map((filter) =>
                filter.id === id ? { ...filter, ...updates } : filter
            )
        );
    }, []);

    const deleteFilter = useCallback((id) => {
        setFilters((prevFilters) => prevFilters.filter((filter) => filter.id !== id));
    }, []);

    const removeAppliedFilter = useCallback((id) => {
        setFilters((prevFilters) => {
            const remaining = prevFilters.filter((filter) => filter.id !== id);
            const nextFilters = remaining.length ? remaining : [initialFilter()];
            setFilterRequest(toFilterRequest(nextFilters));
            return nextFilters;
        });
    }, [initialFilter]);

    const clearFilters = useCallback(() => {
        setFilters([initialFilter()]);
        setFilterRequest((prev) => (Array.isArray(prev) && prev.length === 0 ? prev : []));
    }, [initialFilter]);

    const resetFilters = useCallback(() => {
        setFilters([initialFilter()]);
        setFilterRequest((prev) => (Array.isArray(prev) && prev.length === 0 ? prev : []));
    }, [initialFilter]);

    const contextValue = useMemo(() => ({
        filters,
        applyFilter,
        filterRequest,
        addFilter,
        updateFilter,
        deleteFilter,
        removeAppliedFilter,
        clearFilters,
        resetFilters,
    }), [filters, applyFilter, filterRequest, addFilter, updateFilter, deleteFilter, removeAppliedFilter, clearFilters, resetFilters]);

    return (
        <TaskFilterContext.Provider value={contextValue}>
            {children}
        </TaskFilterContext.Provider>
    )
}

export const useTaskFilter = () => useContext(TaskFilterContext);
